__turbopack_context__.v({
  "img": "LazyImage-module-scss-module__pfc-6G__img",
  "loaded": "LazyImage-module-scss-module__pfc-6G__loaded",
  "skeletonOverlay": "LazyImage-module-scss-module__pfc-6G__skeletonOverlay",
  "wrapper": "LazyImage-module-scss-module__pfc-6G__wrapper",
});
